/*jslint browser */
/*global process */

var $ = jQuery;
declare var document: any;

/**
 *
 */
export default class ProductRankingController
{
    private _productVideoInRankingButton: JQuery;

    constructor()
    {

    }

    public rankingAction(): void
    {
        this.registerEvents();
    }

    /**
     *
     * @private
     */
    private registerEvents(): void
    {
        this._productVideoInRankingButton = $('.product-video-in-ranking-button');

        this._productVideoInRankingButton.on('click', (e) => {
            this.switchVideContainer($(e.currentTarget));
        })
    }

    /**
     *
     * @param ob
     * @private
     */
    private switchVideContainer(ob: JQuery): void {
        $('.video-container-' + ob.data('product')).slideToggle('fast');
    }
}